import { BrowserModule, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { SnotifyModule, ToastDefaults } from 'ng-snotify';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

import { BlAppContext, BlNgCommonModule } from '@blcloud/bl-ng-common';
import { BlNgUiComponentModule } from '@blcloud/bl-ng-ui-component';
import {
  CustomerInfoResource,
  LabelResource,
} from '@blcloud/bl-ng-resource';
import {
  BlNgShareCommonModule,
  BrowserCheckModule,
  CustomerVehicleHeaderModule,
  DealsMemoModule,
  RecallInfoModalModule,
  ReceptionListModalModule,
  AddressGuideModule,
  PostalCodeInputModule,
  PrintConfirmGuideModule,
  GenericPrintModule,
  LabelModule,
  MultiEmployeeGuideModule,
  EmployeeGuideModule,
  SetMenuSelectGuideModule,
  DiscountSelectGuideModule,
  CancelModalModule,
  ShowAgainConfirmModalModule,
  ScheduleTimeTableModule,
  UserGuideModule,
  RemarkGuideModule,
  WarehouseGuideModule,
  SalesPriceProcessDivSettingGuideModule,
  WeightTaxInquiryModule,
  GlassLaborRateGuideModule,
  DotNumberGuideModule,
  RemarksInfoGuideModule,
  TicketGuideModule,
  ContactMemoGuideModule,
  DateModalModule,
  SendSingleMessageModalModule,
  OnlineSalesSettingDetailModule,
  CustomerSearchModule,
  SnsChatWindowModule,
  MaintenanceSheetPrintModule,
  PrintPreviewModalModule,
  ReportOutputStatusGuideModule,
  TallyDivDiscountRateInputGuideModule,
  ExportRequestModalModule,
  DmPrintSelectModalModule,
  DmPrintCommonModule,
  PrintConfirmModalModule,
  DataExportSettingModalModule,
  ExportPatternModalModule,
  ApproachAnnounceDetailModule,
  LineMessageListViewerModule,
  JmsPurchaseHistoryGuideModule,
  ScheduleTaskModule,
} from '@blcloud/bl-ng-share-module';
import {
  TransportBranchGuideModule,
  MakerModelGuideModule,
  InsurCompanyGuideModule,
  RepVehicleEntryModalModule,
  SimpleMakerModelGuideModule,
  VclePridicExchgSimuTabContainerModule,
  VehicleInfoModule,
  BlNgVehicleCustomerModule,
  RepVehicleReceptionLinkModalModule,
  CustomerEntryContainerModalModule,
  ReplacementModalModule,
  CustomerGuideModule,
  CustomerSnsQrOcrModalModule,
  SnsLinkChangeConfirmModalModule,
  SnsLinkConflictModalModule,
  VehicleReferenceSearchGuideModule,
  HolderChangeHistoryModalModule,
  HolderChangeInfoInputModalModule,
  CustomerContactFormComponentModule,
  ExternalProductLinkChangeConfirmModalModule,
} from '@blcloud/bl-ng-vehicle-customer-module';
import { SlipSearchModule, ConformPartsConfirmModalModule } from '@blcloud/bl-ng-slip-module';
import { ReceptExclusiveModule, ReceptEntryModule } from '@blcloud/bl-ng-recept-module';
import {
  EvidenceImageRegisterModule,
  CaseManagementModule,
  EvidenceDocPrintModule,
  CompletionDateSyncModule,
  FileManagementModule,
  EvidenceImageSelectorModule,
  CasesLegendModalModule,
  CaseContentHistoryModalModule,
  EDITING_EVIDENCE_STATE_SELECTOR,
  EditingEvidenceStateForImageSelector,
} from '@blcloud/bl-ng-cases-module';
import {
  SettingManagementService,
  NotifyToastService,
  HdPrintConfirmModule,
  HdReceptionGuideModule,
  HdVcleInspReceptionInfoModalModule,
} from '@blcloud/bl-ng-menu-common-module';

import { environment } from '../environments/environment';
import { config } from '../configs/config';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginPageModule } from './page/login-page/login-page.module';
import { RedirectPageModule } from './page/redirect-page/redirect-page.module';
import { ContactAlertSettingModalModule } from './feature/contact-alert-setting/contact-alert-setting-modal.module';
import { ContactBgColorSettingModalModule } from './feature/contact-bg-color-setting/contact-bg-color-setting-modal.module';
import { ContactInitSettingModalModule } from './feature/contact-init-setting/contact-init-setting-modal.module';
import { ResultFormModalModule } from './feature/result-form-modal/result-form-modal.module';
import { EditModalModule } from './page/contact-list-page/modal/edit-modal.module';
import { ProfileEntriesPageModule } from './page/profile-entries-page/profile-entries-page.module';
import { SnsSendMessageModalModule } from './feature/sns-send-message-modal/sns-send-message-modal.module';
import { SnsSendMessageConfirmModalModule } from './feature/sns-send-message-confirm-modal/sns-send-message-confirm-modal.module';
import { AutoLoginModule } from './core/guard/auto-login/auto-login.module';
import { AutoLoginGuard } from './core/guard/auto-login/auto-login.guard';
import { YahooWarnModalModule } from './page/biz-menu-page/yahoo-warn-modal/yahoo-warn-modal.module';
import { ReportOutputStatusPageModule } from './page/report-output-status-page/report-output-status-page.module';
import { YahooPublikKeyWarnModalModule } from './page/biz-menu-page/yahoo-publickey-warn-modal/yahoo-publickey-warn-modal.module';
import { ReceptScreenActionSettingModule } from './feature/recept-screen-action-setting-modal/recept-screen-action-setting-modal.module';
import { ReceptListModalModule } from './page/recept-list-page/modal/recept-list-modal.module';
import {
  CustomerVehicleSearchScreenActionSettingModule
} from './feature/customer-vehicle-search-screen-action-setting-modal/customer-vehicle-search-screen-action-setting-modal.module';
import {
  SalesSlipSearchScreenActionSettingModule
} from './feature/sales-slip-search-screen-action-setting-modal/sales-slip-search-screen-action-setting-modal.module';
import {
  CompanyNameSelectGuideModule,
  // tslint:disable-next-line:max-line-length
} from './feature/slip-print-detail-setting/tab/slip-print-detail-setting-for-header/company-name-select-guide/company-name-select-guide.module';
import {
  BizMenuPageScreenActionSettingModule
} from './feature/biz-menu-page-screen-action-setting-modal/biz-menu-page-screen-action-setting-modal.module';
import { BizMenuPageModule } from './page/biz-menu-page/biz-menu-page.module';
import { SurveyAddModalModule, SurveyDetailModalModule } from '@blcloud/bl-ng-contact-module';
@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    SnotifyModule.forRoot(),
    BlNgCommonModule.forRoot(),
    BlNgUiComponentModule.forRoot(),
    BlNgShareCommonModule.forRoot(),
    BrowserCheckModule.forRoot(),
    TooltipModule.forRoot(),
    ModalModule.forRoot(),

    // LazyLoadするModuleが利用する各種Modal/Guideが所属するEntryComponentをあわせるために必要なimport
    TransportBranchGuideModule.forRoot(),
    CustomerVehicleHeaderModule.forRoot(),
    DealsMemoModule.forRoot(),
    ScheduleTaskModule.forRoot(),
    RecallInfoModalModule.forRoot(),
    ReceptionListModalModule.forRoot(),
    MakerModelGuideModule.forRoot(),
    InsurCompanyGuideModule.forRoot(),
    RepVehicleEntryModalModule.forRoot(),
    SimpleMakerModelGuideModule.forRoot(),
    VclePridicExchgSimuTabContainerModule.forRoot(),
    VehicleInfoModule.forRoot(),
    BlNgVehicleCustomerModule.forRoot(),
    AddressGuideModule.forRoot(),
    PostalCodeInputModule.forRoot(),
    PrintConfirmGuideModule.forRoot(),
    GenericPrintModule.forRoot(),
    LabelModule.forRoot(),
    MultiEmployeeGuideModule.forRoot(),
    EmployeeGuideModule.forRoot(),
    SetMenuSelectGuideModule.forRoot(),
    DiscountSelectGuideModule.forRoot(),
    CancelModalModule.forRoot(),
    RepVehicleReceptionLinkModalModule.forRoot(),
    ShowAgainConfirmModalModule.forRoot(),
    ReceptExclusiveModule.forRoot(),
    CustomerEntryContainerModalModule.forRoot(),
    WeightTaxInquiryModule.forRoot(),
    GlassLaborRateGuideModule.forRoot(),
    SlipSearchModule.forRoot(),
    ConformPartsConfirmModalModule.forRoot(),
    DotNumberGuideModule.forRoot(),
    ScheduleTimeTableModule.forRoot(),
    TicketGuideModule.forRoot(),
    ReceptEntryModule.forRoot(),
    ReplacementModalModule.forRoot(),
    DateModalModule.forRoot(),
    SendSingleMessageModalModule.forRoot(),
    ContactAlertSettingModalModule.forRoot(),
    ContactBgColorSettingModalModule.forRoot(),
    ContactInitSettingModalModule.forRoot(),
    ResultFormModalModule.forRoot(),
    EditModalModule.forRoot(),
    SnsChatWindowModule.forRoot(),
    CustomerGuideModule.forRoot(),
    CustomerSearchModule.forRoot(),
    CustomerSnsQrOcrModalModule.forRoot(),
    SnsLinkChangeConfirmModalModule.forRoot(),
    SnsLinkConflictModalModule.forRoot(),
    ExternalProductLinkChangeConfirmModalModule.forRoot(),
    MaintenanceSheetPrintModule.forRoot(),
    PrintPreviewModalModule.forRoot(),
    ReceptScreenActionSettingModule.forRoot(),
    ExportRequestModalModule.forRoot(),
    CustomerVehicleSearchScreenActionSettingModule.forRoot(),
    SalesSlipSearchScreenActionSettingModule.forRoot(),
    BizMenuPageScreenActionSettingModule.forRoot(),
    SurveyDetailModalModule.forRoot(),
    SurveyAddModalModule.forRoot(),
    DmPrintSelectModalModule.forRoot(),
    DmPrintCommonModule,
    PrintConfirmModalModule.forRoot(),
    FileManagementModule.forRoot(),
    EvidenceImageSelectorModule.forRoot(),
    ApproachAnnounceDetailModule.forRoot(),
    CasesLegendModalModule.forRoot(),
    LineMessageListViewerModule.forRoot(),
    CaseContentHistoryModalModule.forRoot(),

    AppRoutingModule,
    LoginPageModule,
    RedirectPageModule,
    UserGuideModule.forRoot(),
    RemarkGuideModule.forRoot(),
    WarehouseGuideModule.forRoot(),
    SalesPriceProcessDivSettingGuideModule.forRoot(),
    ContactMemoGuideModule.forRoot(),
    ProfileEntriesPageModule.forRoot(),
    RemarksInfoGuideModule.forRoot(),
    OnlineSalesSettingDetailModule.forRoot(),
    SnsSendMessageModalModule,
    SnsSendMessageConfirmModalModule,
    AutoLoginModule,
    YahooWarnModalModule.forRoot(),
    YahooPublikKeyWarnModalModule.forRoot(),
    ReportOutputStatusPageModule,
    ReportOutputStatusGuideModule.forRoot(),
    VehicleReferenceSearchGuideModule.forRoot(),
    TallyDivDiscountRateInputGuideModule.forRoot(),
    HdPrintConfirmModule.forRoot(),
    HdReceptionGuideModule.forRoot(),
    HdVcleInspReceptionInfoModalModule.forRoot(),
    HolderChangeHistoryModalModule.forRoot(),
    CustomerContactFormComponentModule.forRoot(),
    HolderChangeInfoInputModalModule.forRoot(),
    ReceptListModalModule.forRoot(),
    EvidenceImageRegisterModule.forRoot(),
    CaseManagementModule.forRoot(),
    CompanyNameSelectGuideModule,
    ExportPatternModalModule.forRoot(),
    DataExportSettingModalModule.forRoot(),
    EvidenceDocPrintModule.forRoot(),
    CompletionDateSyncModule.forRoot(),
    BizMenuPageModule,
    // ↓ジェームス処理
    JmsPurchaseHistoryGuideModule.forRoot(),
    // ↑ジェームス処理
  ],
  declarations: [
    AppComponent
  ],
  providers: [
    Title,
    SettingManagementService,
    { provide: 'SnotifyToastConfig', useValue: ToastDefaults },
    NotifyToastService,
    AutoLoginGuard,
    CustomerInfoResource,
    LabelResource,
    { provide: EDITING_EVIDENCE_STATE_SELECTOR, useClass: EditingEvidenceStateForImageSelector },
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  /**
   * コンストラクタ
   * @param context コンテキスト
   */
  constructor(context: BlAppContext) {
    // 設定を保持
    context.environment = environment;
    context.config = config;
  }
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts